"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('earth', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), _react.default.createElement("path", {
    d: "M0,20 L40,20"
  }), _react.default.createElement("ellipse", {
    cx: "20",
    cy: "20",
    rx: "8",
    ry: "20"
  }), _react.default.createElement("path", {
    d: "M5.85786438,6.14213562 C9.4771525,9.76142375 14.4771525,12 20,12 L20,12 C25.5228475,12 30.5228475,9.76142375 34.1421356,6.14213562"
  }), _react.default.createElement("path", {
    d: "M34.1421356,33.8578644 C30.5228475,30.2385763 25.5228475,28 20,28 C14.4771525,28 9.4771525,30.2385763 5.85786438,33.8578644"
  })))));
});

exports.default = _default;